/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <br>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1200">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-progress-linear v-if="progresso" indeterminate color="green" height="10"></v-progress-linear>

          <div class="top_info_container">
            <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Cadastrar Estudante </v-btn>
            <v-toolbar-title class="titulo_pagina"> Consultar Estudantes Registrados </v-toolbar-title>
            <v-btn to="/estudantes/menu" color="blue" fab small> <v-icon small color="white">arrow_back</v-icon> </v-btn >
          </div>

          <div class="top_info_search_container">
            <input type="text" v-model="searchInDb" placeholder="Pesquise pelo estudante" append-icon="search" label="Pesquisa" single-line hide-details class="input_search">
            <v-btn class="input_search_btn" small fab color="green" v-if="searchInDb" style="background-color:yellow; color: white;"><v-icon>search</v-icon></v-btn>
          </div>

          <template>
            <v-data-table :headers="headers" :search="searchInDb" :items="produtos" :items-per-page="8">
              <template v-slot:item.indice="{ item }">
                <span>{{ produtos .indexOf(item) + 1 }}</span>
              </template>
              <template v-slot:item.bolseiro="{item}">
                <p> {{ item.bolseiro == 1 ? 'Sim' : 'Não' }}</p>
              </template>
              <template v-slot:item.classe="{item}">
                <p > {{ item.classe == 1 ? '10ª' :  item.classe == 2 ? '11ª': item.classe == 3? '12ª': item.classe === 4 ?'13ª':'Inváido' }}</p>
              </template>
        
              <template v-slot:item.action="{ item }">
                <v-menu :offset-x="offsetX" :offset-y="offsetY" bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="mudarNovoEstudante(item)">
                      <v-icon color="green">sync</v-icon> Mudar para Antigo
                    </v-list-item>

                    <v-list-item @click="showEditarDados(item)">
                      <v-icon color="blue">edit</v-icon> Editar Dados
                    </v-list-item>

                    <v-list-item v-if="item.bolseiro != 1" @click="registrarBolseiro(item)">
                      <v-icon color="green">person</v-icon> Registrar Bolseiro
                    </v-list-item>

                     <v-list-item  @click="showAlertas(item)">
                      <v-icon color="green">info</v-icon> Definir Alertas
                    </v-list-item>

                    <v-list-item  @click="imprimirFichaConfirmacao(item)">
                      <v-icon color="red">print</v-icon> Imprimir Ficha
                    </v-list-item>
                    
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </template>

           <!-- ========= DIALOGO REGISTRAR BOLSEIRO ================ -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="tipoBolseiroSelected" :disabled="true" label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="valorDesconto" :disabled="true"  label="Valor do desconto"></v-combobox>
                    </v-col>
                  </v-row>
                  <p v-if="descricaoBolseiro">*{{ descricaoBolseiro }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- ========== NOVA ORGANIZAÇÃO ============== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="cardNovaOrganizacao" persistent max-width="500px">
                <v-card>
                  <v-overlay :value="overlayOrganizacao">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title>
                    <span class="headline">Nova Organização</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="nomeNovaOrganizacao" label="Forneça o nome da nova organização"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-combobox :rules="ruleRequired" v-model="idNovaOrganizacao" :items="tipoBolseiroOng" item-value="tipoBolseiroOng" item-text="descricao" return-object label="Tipo de bolseiro:" >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descricao"></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-combobox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid" @click="verificarOrganizacao()">Guardar</v-btn>
                    <v-btn @click="fecharCardNovaOrganizacao()">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ========= FIM NOVA ORGANIZAÇÃO ================ -->


          <!-- ============ DIALOGO NOVO ESTUDANTE ============ -->
          <v-dialog v-model="dialog"  max-width="800px">
            <cadastrar-estudante></cadastrar-estudante>
          </v-dialog>
          <!-- =============================================== -->

          
          <!-- ======================== DIALOGO EDITAR DADOS DO ESTUDANTE ===================================== -->
          <v-dialog v-model="dialogEditar"  max-width="800px">
            <editar-estudante v-if="dialogEditar" :municipios="municipiosAll" :provincias="provincias" :estudante="this.editedItem"></editar-estudante>
          </v-dialog>
          <!-- =================================================================================================== -->


          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="MudarTipoEstudante()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- ************************************************************* -->
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
import impressaoUtilitario from '../../utilitarios/impressao.utilitario'
import cadastrarEstudante from './componentes/estudante/cadastrar.vue'
import editarEstudante from './componentes/estudante/editar.vue'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  directives: { mask },
  components: { 
    cadastrarEstudante ,
    editarEstudante
    },
  data: () => ({
    cardBolseiro: false,
    dialogNotification:false,
    editarDados:false,
    mostrarOpcoesBolsa: false,
    dialogEditar: false,
    tipoDeBolsa: '',
    descricaoBolseiro: '',
    tipoBolseiroOng: [],
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: '',
    idNovaOrganizacao: null,
    bolseiroSelected: null,
    valorDesconto: '',
    tipoBolseiroSelected: '',
    listaOngBolsas: [],
    ongBolsaSelected: null,
    showConfirmacao: false,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    classes: [],
    classesFiltered: [],
    turmasAll: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [
      value => !!value || 'campo obrigatório.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Nome', align: 'start', sortable: false, value: 'nome'},
      { text: 'Bi', value: 'bi' },
      { text: 'Matrícula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso_descricao' },
      { text: 'Bolseiro', value: 'bolseiro'},
      { text: 'Classe', value: 'classe' },
      { text: 'Data registro', value: 'data_cadastro' },
      { text: 'Autor', value: 'autor' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    config: null,
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    overlay: false,
    numeroEstudantesCadastrado: [],
    estudanteObjecto: null,
    dialogoConcordar: false,
    editedItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      periodo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:''
    },
    defaultItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      periodo: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:'',
    }
  }),

  computed: {

    vagasDisponiveis(){
      return parseInt((this.editedItem.turma === null || this.editedItem.turma == undefined)?0:this.editedItem.turma.capacidade) - parseInt((this.numeroEstudantesCadastrado.length)?this.numeroEstudantesCadastrado[0].qtdEstudante:0)
    },




    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    nivelEnsino() {
      return ls.get('nivel')
    },
    role() {
      return ls.get('role')
    },
    isAtlantidaOrMazozo() {
      return true//window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10') || window.location.host.includes('ispamazozo.com')
    },
    anoLectivoSistema() {
      return ls.get('anolectivo')
    },

    urlImpressao() {
      return ls.get('url_impressao')
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize();
    this.carregarDadosBolseiros();
    this.initializeProvincias();
    this.initializeMunicipios();
    this.initializeCursos();
    this.initializeturmasAll()
    this.config = impressaoUtilitario.getConfig()
    this.getUrlImpressao()
    if (this.nivelEnsino !== 1) {
      this.initializeClasses();
    }
  },

  methods: {
    async getUrlImpressao () {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url)
      } catch (error) {
        console.log(error)
      } finally {
      }
    },

    async showAlertas(){
      Swal.fire('Informação','Função indisponível de momento','warning')
       // this.dialogNotification = true
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initialize() {
      try {
        this.progresso = true;
        this.produtos = await axios.get('/estudantesFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeProvincias() {
      try {
        this.progresso = true;
        this.provincias = await axios.get('/provinciaFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },


    async imprimirFichaConfirmacao (item) {
      try {
        this.overlay = true
        let infoEstudante = await this.ObterHistoricoAcademico({idMatricula:item.idMatricula}).then((res)=>res.data)
        this.comporHtml(infoEstudante[0])
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }    
    },

    async comporHtml (estudante) {
      try {
        this.html = `
<html>
<head>
<style>
  body {font-family: Arial, sans-serif;}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 0px;
  font-family: Arial, sans-serif;
}
.heading td { border: 1px solid #ddd;}
.centerColumn {
  text-align: center;
  padding: 16px;
}

.wordcenter {text-align:center;}
.titulo { font-size:14px;font-weight:bold;}
.titulo2 { font-size:12px;font-weight:bold;}
.table2 td{ font-size:12px;text-align:left;}
.heading2 td{ font-size:12px;border: 1px solid #ddd;}
.heading3 td{ font-size:12px;text-align:center;}
.distanciaEntrelinhas {padding: 10px 0px 10px 0px;}
.distanciaEntrelinhasDadosPessoais {padding: 5px 0px 5px 0px;}
.borda { border:1px solid #000;}
.bordaBottom { border-bottom:1px solid #000;}
.bordaTop { border-top:1px solid #000;}
.negrito { font-weight:bold;}
.larguraInquerito1 {width:30%;}
.larguraInquerito2 {width:70%;}

.versoTable td{ font-size:12px;line-height:30px;}
.frenteVerso {margin-top:150px;}
div.groove {border-style: groove;padding:0px 8px 0px 8px;}
</style>
</head>
<body>
  
    <table class="heading">
       <tr>
    <td align="center" rowspan="2"><img height="92px" src="data:image/png;base64,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"/></td>
    <td rowspan="2" style="border:0px;"></td>
    <td class="centerColumn titulo" style="border-bottom:0px;">Escola de Saúde Castelo</td>
     </tr>
     <tr> <td class="centerColumn titulo2" style="border-top:0px;">FICHA DE MATRÍCULA E CONFIRMAÇÃO DE MATRÍCULA</td></tr>
    </table>
 <br>
 <table class="heading2">
       <tr>
          <td style="border-right:0px;border-bottom:0px;">PREENCHER PELA SECRETARIA</td>
          <td style="border-left:0px;border-bottom:0px;">Nº do Processo:______________________</td>
          <td rowspan="2" style="border:0px;"></td>
          <td align="center" rowspan="2"><img height="92px"/></td>
    
     </tr>
     <tr> 
       <td style="border-right:0px;border-top:0px;">TÉCNICO-PROFISSIONAL</td>
       <td style="border-left:0px;border-top:0px;">[X] `+estudante.classe+`</td>
     </tr>
    </table>

    <table class="heading3">
      <tr>
        <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] MATRÍCULA</td>
        <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] CONFIRMAÇÃO</td>
      </tr>
    </table>
 
 
<h5>DADOS PESSOAIS DO ALUNO</h5>
<table class="table2">
  <tr><td colspan="2">Nome do(a) Aluno(a): <span style="font-weight:bold;text-decoration:underline;">`+estudante.nome+`</span></td></tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr><td colspan="2">Nascido aos `+this.retornaData(estudante.datanascimento)+`,no município <span style="font-weight:bold;text-decoration:underline;">`+estudante.municipio+`</span>, na província <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span></td></tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr> <td colspan="2">Residente em, <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span></td> </tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr><td colspan="2">portador de Bilhete, nº <span style="font-weight:bold;text-decoration:underline;">`+estudante.bi+`</span> Arquivo de <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span>, aos <span style="font-weight:bold;text-decoration:underline;">`+this.retornaData(estudante.dataemissaobi)+`</span></td></tr>

  <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr><td colspan="2"><h5>SITUAÇÃO DO ANO LECTIVO ANTERIOR</h5></td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Frequentou o ano lectivo <span style="font-weight:bold;">`+(ls.get('anolectivo')-1)+`</span>, a turma <span style="font-weight:bold;text-decoration:underline;">_________________</span> da <span style="font-weight:bold;text-decoration:underline;">_________________</span> ª classe na instituição <span style="font-weight:bold;text-decoration:underline;">_________________________________________</span></td></tr>
   <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr> 
     <td colspan="2" class="bordaTop"> 
    [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] O aluno está sinalizado como Necessidades Educativas Especiais.<br>
    (Em  caso de resposta afirmativa, anexar Relatório Médico). 
    </td> 
   <td></td> 
   </tr>
<tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="2"><h5>SITUAÇÃO PARA O ANO LECTIVO <span style="font-weight:bold;">`+ls.get('anolectivo')+`</span></h5></td></tr>
    <tr><td colspan="2">No presente ano lectivo, pretende matricular-se na <span style="font-weight:bold;">`+estudante.classe+`</span> <span style="font-weight:bold;">`+estudante.curso+`</span> - `+estudante.turma+`.</td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Em caso de necessidade, autorizo o aluno a ser  observado pela Equipa de Intervenção Multidisciplinar.</td></tr>
   <tr><td colspan="2"><h5>Para as ofertas abaixo informe-se junto da Secretaria do Preço e das Condições de acesso e preencha os respectivos formulários.</h5></td></tr>


   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Pretende transporte escolar.</td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Pretende frequentar o A.T.L/[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Aulas de Reforço.</td></tr>
<tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr><td colspan="2"><h5>INQUÉRITO DE SAÚDE (Riscar o que não interessa ou acrescentar informação)</h5></td></tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Alergia: Não [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Sim [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Se sim, quais: </td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
    </tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Cuidados Especiais de </td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
   </tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Doenças crónicas: Não [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Sim [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Se Sim, quais:</td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
   </tr>
   <tr>
     <td class="distanciaEntrelinhas">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Em caso de febre poderá ser administrado: ben-u-ron, xarope, supositórios, </td>
     <td class="bordaBottom distanciaEntrelinhas"></td>
   </tr>
    <tr><td colspan="2" class="bordaBottom distanciaEntrelinhas"></td></tr>
    <tr>
      <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] O aluno tem a seguinte restrição ou alergia alimentar:</td>
      <td class="bordaBottom"></td>
    </tr>
     <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="2" class="distanciaEntrelinhas borda"></td></tr>
</table>
<div class="frenteVerso"></div>
<div class="groove">
<table class="versoTable">
  <tr><td class="wordcenter titulo" colspan="3">DADOS PESSOAIS DOS PAIS E DO ENCARREGADO DE EDUCAÇÃO</td></tr>
  <!-- Pai -->
  <tr><td colspan="3">Pai <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedopai+`</span> </td></tr>
  <tr>
    <td>Estado Civil __________________________</td>
    <td>Naturalidade __________________________</td>
    <td>Residente em __________________________</td>
    </tr>
    <tr>
    <td>Telefone </td>
    <td colspan="2">Email __________________________</td>
    </tr>
    <tr>
    <td>Profissão </td>
    <td colspan="2">Local de trabalho __________________________</td>
    </tr>
    <!-- Mãe -->
    <tr><td colspan="3">Mãe <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedamae+`</span></td></tr>
  <tr>
    <td>Estado Civil __________________________ </td>
    <td>Naturalidade __________________________ </td>
    <td>Residente em __________________________ </td>
    </tr>
    <tr>
    <td>Telefone __________________________ </td>
    <td colspan="2">Email __________________________ </td>
    </tr>
    <tr>
    <td>Profissão __________________________ </td>
    <td colspan="2">Local de trabalho __________________________</td>
    </tr>
    <!-- Encarregado de educação -->
     <tr>
    <td colspan="1" style="font-weight:bold;">Encarregado de Educação</td>
    <td>Grau de Parentesco </td>
    <td><span style="font-weight:bold;text-decoration:underline;">Pai</span> </td>
    </tr>
    <tr><td colspan="3">(Se pai ou mãe não precisa de preencher mais nenhuma informação)</td></tr>
     <tr>
    <td>Estado Civil </td>
    <td>Naturalidade </td>
    <td>Residente em </td>
    </tr>
    <tr>
    <td>Telefone </td>
    <td colspan="2">Email </td>
    </tr>
    <tr>
    <td>Profissão </td>
    <td colspan="2">Local de trabalho </td>
    </tr>
    
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="titulo">Documentos Entregues</td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="wordcenter titulo2">TERMO DE RESPONSABILIDADE</td></tr>
    <tr><td colspan="3">Eu, <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedopai+`</span>, Encarregado de Educação do(a) aluno(a) <span style="font-weight:bold;text-decoration:underline;">`+estudante.nome+`</span> da <span style="font-weight:bold;text-decoration:underline;">`+estudante.classe+`</span> comprometo-me a cumprir com todas as obrigações do Regulamento Interno no Instituto Técnico Privado de Saúde Ilha da Verdade.</td></tr>
<tr>
  <td class="wordcenter negrito">Assinatura do Encarregado de Educação</td>
  <td></td>
  <td class="wordcenter negrito">Assinatura do Colabordor</td>
</tr>
<tr>
  <td class="bordaBottom"></td>
  <td></td>
  <td class="bordaBottom"></td>
</tr>
<tr>
  <td class="wordcenter">___/____/_____</td>
  <td></td>
  <td class="wordcenter">___/____/_____</td>
</tr>
<tr><td colspan="3">O processo de candidatura está pendente por falta dos seguintes documentos:______________________________________</td></tr>
<tr><td colspan="3" class="bordaBottom distanciaEntrelinhas"></td></tr>
<tr><td colspan="3" class="bordaBottom distanciaEntrelinhas"></td></tr>
<tr><td colspan="3">Notas: Todos os documentos passados pelas escolas privadas são provisórios e têm  a duração de 90 dias.<br>
  A matrícula é condicional durante 45 dias e até á apresentação de todos os doocumentos solicitados.</td></tr>

</table>
</div>

</body>
</html>
`
let options = {
            'format': 'A4',
            'border': { 'right': '5mm', 'left': '5mm' },
            'header': { 'height': '5mm' },
            'footer': { 'height': '5mm' }
          }

        this.gerarPDF(options)
      } catch (error) {
        console.log(error)
      }
    },
    async  gerarPDF (options) {
        this.isLoading = true
        try {
          await axios({
            method: 'post',
           // url: 'http://eftsl.softlineangola.com:8082/writefile',
           url: `${this.urlImpressao}writefile`,
            data: {
              html: this.html,
              file_name: ls.get('nomeUsuario'),
              option: options
            }
          }).then()
          // Imprimir PDF
         this.frame()
        } catch (error) {
        }
      },
      frame () {
       let link = `${this.urlImpressao}readfile/`+ls.get('nomeUsuario')+'.pdf'
        let frame = `<html> +
        <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
        <body>
        <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
        </body></html>`
        let a = window.open('about:blank', '_blank', '', true)
        a.document.write(frame)
        a.document.close()
      },

     async  ObterHistoricoAcademico(params){
       try {
          return await axios.post('/ObterInscricaoTurmaEstudante',params)
        } catch (error) {
          Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','warning')
       }

    },

    retornaData(data){
      let info = data.split('-')
      return info[2]+'-'+info[1]+'-'+info[0]
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios.get('/cursoInstituicaoFindAllIntegracao').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally { 
        this.isLoading = false;
      }
    },

    outroDoc() {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = '';
        this.descricao = 'Nº do Bi';
        this.mascara = '#########-AA-###';
        this.ruleBI = [ value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'];
      } else {
        this.editedItem.bi = '';
        this.descricao = 'Outro Doc.';
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
        this.ruleBI = [ value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'];
      }
    },

    async mudarNovoEstudante(item) {
      this.estudanteObjecto = item;
      this.dialogoConcordar = true;
    },
    
    showEditarDados(item) {
      this.editedItem = item
      this.dialogEditar = true
    },

    async MudarTipoEstudante() {
      try {
        this.progresso = true;
        let resultado = await axios.post('/mudarTipoEstudante', { estudante: this.estudanteObjecto, tipo: 1 }).then(res => res.data);
        if (resultado.affectedRows >= 1) {
          this.dialogoConcordar = false;
          Swal.fire('Informação', '<p>Actualização efectuada com sucesso.</p>', 'success');
          this.initialize();
        }
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get('/classeFindAll2').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios.get('/turmasFindAlls').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeMunicipios() {
      try {
        this.progresso = true;
        this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

    async Save() {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params = {
          pk_estudante: this.editedItem.pk_estudante,
          nome: this.editedItem.nome,
          nif: this.editedItem.nif,
          morada: this.editedItem.morada,
          telefone1: this.editedItem.telefone,
          telefone2: this.editedItem.telefone2,
          email: this.editedItem.email,
          observacao: this.editedItem.observacao,
          produtosDesconto: null,
          descontoPorProduto: null,
          OpcaodescontoGlobal: null,
          descontoGlobal: null
        }

        try {
          //   let  payload =""
          let msg = await axios.post('/clienteInsertOrUpdate', params).then(res => res.data)
          if (msg) {
            this.initialize()
            this.showAlert()
            //this.Limpar()
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false;
        }
      }
    },

    showAlert() {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Actualização efectuada com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    Limpar() {
      this.editedItem.nome = '';
      this.editedItem.datanascimento = '';
      this.editedItem.nomedopai = '';
      this.editedItem.nomedamae = '';
      this.editedItem.dataemissaobi = '';
      this.editedItem.telefone = '';
    },

    openDialog() {
      this.dialog = true;
      this.editarDados = false
    },

    loadTurmaComb() {
      this.turmasFiltered = []
      this.editedItem.turma = null
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.curso.idCurso && t.idAno_Academico === this.editedItem.classeSelected.id)
      console.log(this.turmasFiltered);
    },

    loadMunicipioComb(provincia) {
      this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia);
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(this.editedItem.curso.numero_anos_academicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    loadclasseEditar(numeroAnoAcademicos, anoacademicoEstudante) {
      /**
      * Nivel Ensino
      * 1 - Superioor
      * 2 - Médio
      */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(numeroAnoAcademicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
        this.editedItem.classeSelected = this.classesFiltered.filter(c => c.id === anoacademicoEstudante)[0]
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
            estudante: this.editedItem,
            nome: (this.editedItem.nome.length <= 0 || this.editedItem.nome === null) ? this.editedItem.nome : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nomedopai: (this.editedItem.nomedopai.length <= 0 || this.editedItem.nomedopai === null) ? this.editedItem.nomedopai : utilitarios.SetNameCapitalize(this.editedItem.nomedopai.trim()),
            nomedamae: (this.editedItem.nomedamae.length <= 0 || this.editedItem.nomedamae === null) ? this.editedItem.nomedamae : utilitarios.SetNameCapitalize(this.editedItem.nomedamae.trim()),
            autor: ls.get('nomeUsuario'),
            turmaSelected: this.editedItem.turma,
            tipoEstudante: 0, // Estudante antigo, apeans não paga matricula
          }
           let result = await axios.post('estudanteInsertOrUpdate', params)
            if (result.data.affectedRows >= 1) {
              Swal.fire({
                    title: 'Informação',
                    text: "Estudante cadastrado e/ou Actualizado com sucesso!",
                    icon: 'success',
                    showCancelButton: true,
                    cancelButtonText:'Fechar',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ir em pagamentos ?',
                    reverseButtons:true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.$router.push('esc-pagamento')
                      window.location.reload(true)
                    }
                  })
              this.dialog = false;
              this.editedItem = this.defaultItem;
              this.initialize();
              this.editarDados = false
            } else if (result.data.status === 1122) { // For duplicate entry
              Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
            } else {
              utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
            }
           
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        } finally { 
          this.overlay = false; 
        }
      }
    },

    /**
     * Método responsavél por fechar o cardNovaOrganizacao.
     * reseta o valor da variavél nomeNovaOrganizacao
    */
    fecharCardNovaOrganizacao() {
      this.nomeNovaOrganizacao = '';
      this.idNovaOrganizacao = null;
      this.cardNovaOrganizacao = false;
    },

    
    async ObterNumeroEstudantesTurma (){
      try {
        this.numeroEstudantesCadastrado = await axios.post('ObterNumeroIscritoEstudantesTurma',{turma:this.editedItem.turma}).then((res)=>res.data)
      } catch (error) {
        
      }
    },

    //======== FUNÇÕES LIGADAS AS CADASTRO E FUNCIONAMENTO DOS BOLSEIROS ========== */

    /**
     * Método responsavél por carregar os dados que serão necessário para registrar um bolseiro.
     * Trás a lista das organizações provedoras de bolsa disponivel
     * Trás a lista de todos os tipos de bolseiros salvo no Banco de dados
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async carregarDadosBolseiros() {
      try {
        this.progresso = true;
        this.listaOngBolsas = await axios.get('/listarOrganizacoesBolsas').then((res) => res.data);
        this.listaOngBolsas.unshift({ nome: 'Nova Organização', id: -1, icone: true });
        this.tipoBolseiroOng = await axios.get('/obterDescricaoBolseiros').then((res) => res.data);
      } catch (error) {
        utilitarios.showAlertMessage('error', 'Ocorreu um error durante o carregamento da página!')
      } finally {
        this.progresso = false;
      }
    },

    /**
     * Método responsavél tornar o cardBolseiro visivél.
     * Armazena os dados do estudante selecionado na variavél bolseiroSelected
    */
    registrarBolseiro(estudante) {
      console.log(estudante);
      this.cardBolseiro = true;
      this.bolseiroSelected = estudante;
    },

     /**
     * Método responsavél tornar o cardNovaOrganizacao visivél.
     * Verifica se o usuário clicou na opcção "Nova Organização"
     * Reseta o valor da variavel ongBolsaSelected
     * Fecha o cardBolseiro
    */
    SelecionarOrganizacao() {
      this.mostrarOpcoesBolsa = false;
      if (this.ongBolsaSelected.tipo_bolseiro == 1) {
        this.tipoDeBolsa = 1;
        this.valorDesconto = "100%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza são isentos de mensalidades e multas.";
      } else if(this.ongBolsaSelected.tipo_bolseiro == 2) {
        this.tipoDeBolsa = 2;
        this.valorDesconto = "0%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza estão isentos do pagamento de multas decorrentes de atrasos no pagamento.";
      } else {
        this.tipoDeBolsa = 3;
        this.tipoBolseiroSelected = "Comparticipada";
        this.valorDesconto = "50%";
        this.descricaoBolseiro = "Os bolseiros desta natureza possuem direito a um desconto de 50% no pagamento da mensalidade.";
        this.mostrarOpcoesBolsa = true;
      }

      if (this.ongBolsaSelected.id === -1) {
        this.cardNovaOrganizacao = true;
        this.ongBolsaSelected = null;
        this.fecharCardBolseiro();
      }
    },

    /**
     * Método responsavel por verificar se a organização já foi cadastrada.
     * Verica se o nome que está a ser inserido já existe no banco de dados
     * Valida se o campo está vázio
     * Se a organização já foi cadastrada antes, será exibido uma notificação
     * Se ainda não foi cadstrada, será chamado o método responsavél por cadastrar
    */
    async verificarOrganizacao() {
      if (this.$refs.form.validate() && this.nomeNovaOrganizacao) {
        let organizacaoExistente = await axios.get(`/verificarOrganizacaoExistente/${this.nomeNovaOrganizacao.trim()}`).then((res) => res.data);
        if (organizacaoExistente.length) {
          utilitarios.showAlertMessage('error', 'Organização já registrada!')
        } else {
          this.saveNovaOrganizacao();
        }
      }
    },

    /**
     * Método responsavél por cadastrar a nova organização inserida.
     * Se o cadastro ocorrer com sucesso, fecha o cardNovaOrganizacao e chamará a função this.carregarDadosBolseiros();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async saveNovaOrganizacao() {
      if (this.$refs.form.validate()) {
        let params = {
          tipo_bolseiro: this.idNovaOrganizacao.tipoBolseiro,
          nomeOrgazacao: this.nomeNovaOrganizacao.trim()
        }
        try {
          this.overlayOrganizacao = true;
          let result = await axios.post('/cadastrarNovaOrganizacao', params).then((res) => res.data);
          if(result.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Organização adicionada com sucesso!');
            this.fecharCardNovaOrganizacao();
            // this.carregarDadosBolseiros();
            location.reload();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao adicionar a nova organização!')
        } finally {
          this.overlayOrganizacao = false;
        }
      }
    },

    /**
     * Método responsavel por verificar se o bolseiro já foi cadastrado.
     * Verifica se o bilhete (nif) já existe na tabela bolseiros
     * Se o bolseiro já foi cadastrado antes, será exibido uma notificação
     * Se ainda não foi cadstrado, será chamado o método responsavél por cadastrar
    */
    async verificarBolseiroCadastrado() {
      if (this.$refs.form.validate()) {
        let bolseiroExistente = await axios.get(`/vericarBolseiroExistente/${this.bolseiroSelected.idMatricula}`).then((res) => res.data);
        if (bolseiroExistente.length) {
          utilitarios.showAlertMessage('error', 'Bolseiro já registrado! Verifique a lista dos bolseiros revogados.')
        } else {
          this.salvarBolseiro();
        }
      }
    },

     /**
     * Método responsavél por cadastrar umnovo bolseiro.
     * Se o cadastro correr com sucesso, fecha o fecharCardBolseiro e chamará a função this.initialize();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async salvarBolseiro() {
      if (this.$refs.form.validate()) {
        let params = {
          nome: this.bolseiroSelected.nome,
          anoLectivo: this.anoLectivoSistema,
          curso: this.bolseiroSelected.curso_descricao,
          nif: this.bolseiroSelected.bi,
          matricula: this.bolseiroSelected.idMatricula,
          ongBolsa: this.ongBolsaSelected.nome,
          tipoBolsa: this.tipoDeBolsa,
          desconto: this.valorDesconto
        }
  
        try {
          this.overlay = true;
          let result = await axios.post('/registrarBolseiro', params).then((res) => res.data);
          if(result.affectedRows >= 0) {
            utilitarios.showAlertMessage('success', 'Bolseiro registrado com sucesso.')
            this.fecharCardBolseiro();
            location.reload();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro durante o registro do bolseiro!');
        } finally {
          this.overlay = false;
        }
      }
    },

     /**
     * Método responsavél tornar o cardBolseiro invisivél.
     * Reseta o valor das variaveis tipoBolseiroSelected, valorDesconto, ongBolsaSelected
    */
    fecharCardBolseiro() {
      this.tipoBolseiroSelected = null;
      this.valorDesconto = '';
      this.descricaoBolseiro = '';
      this.ongBolsaSelected = null;
      this.mostrarOpcoesBolsa = false;
      this.cardBolseiro = false;
    }
    //======== FIM FUNÇÕES LIGADAS AS CADASTRO E FUNCIONAMENTO DOS BOLSEIROS ========== */
  }
}
</script>
<style scoped></style>
